import React, { useEffect, useState } from "react"
import _, { get } from "lodash"
import { ensureArray } from "services/utils/validation"
import {
  getClientDetailsAssets,
  getClientDetailsOrders
} from "services/state/fixedVoice/action"
import { connect } from "react-redux"
import TableFixedVoice from "../../../components/Inputs/TableFixedVoice"
import PropTypes from "prop-types"
import { formatDateFns } from "services/utils/date"
import {
  headersAsset,
  headersOrder,
  optionsActionsAssets,
  optionsActionsOrders
} from "./constants"
import styles from "./styles.css"

const assetFactory = (value) => {
  const date = get(value, "CRIADO EM", "")
  const dateActive = get(value, "ATIVO EM", null)

  return {
    id: get(value, "ASSET", ""),
    numero: get(value, "NUMERO", ""),
    type: _.capitalize(get(value, "TYPE", "")),
    criado: formatDateFns(date, "dd-MMM-yy", "dd/MM/yyyy"),
    estado: get(value, "ESTADO", ""),
    cidade: get(value, "CIDADE", ""),
    ativo: dateActive
      ? formatDateFns(dateActive, "dd-MMM-yy", "dd/MM/yyyy")
      : ""
  }
}

const orderFactory = (value) => {
  const date = get(value, "CRIADO EM", "")

  return {
    protocolo: get(value, "PROTOCOLO", ""),
    numero: get(value, "TELEFONE", ""),
    type: _.capitalize(get(value, "PROTOCOLO TYPE", "")),
    criado: formatDateFns(date, "dd-MMM-yy", "dd/MM/yyyy"),
    estado: get(value, "PROTOCOLO UF", ""),
    cidade: get(value, "PROTOCOLO LOCALIDADE", ""),
    status: get(value, "SUB STATUS PROTOCOLO", ""),
    obs: {
      reason: get(value, "ORDEM IMTERROMPIDA", null),
      windowsPort: get(value, "JANELA PORTABILIDADE", null),
      fluxoDeTrabalho: get(value, "FLUXO DE TRABALHO", null)
    }
  }
}

const convertRecord = (isAsset, records) => {
  return _.map(records, (value, key) => {
    return isAsset ? assetFactory(value) : orderFactory(value)
  })
}

const ClientNumbers = ({
  customer,
  numbers,
  loading,
  isLimitAchieved,
  error,
  type,
  filter,
  status,
  getClientDetailsAssets,
  getClientDetailsOrders
}) => {
  const recordObject = get(numbers, "records", [])
  const totalPages = get(numbers, "totalPage", 1)
  const statusSelected = get(status, "status", "")
  const isAsset = type === "ASSET"

  const headerSelected = isAsset ? headersAsset : headersOrder

  const optionsSelected = isAsset ? optionsActionsAssets : optionsActionsOrders

  const records = convertRecord(isAsset, ensureArray(recordObject))
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    const customerDocument = get(customer, "document", null)

    if (!customerDocument) {
      return
    }

    if (isAsset) {
      getClientDetailsAssets({
        page: currentPage,
        partnerDoc: customerDocument,
        status: statusSelected
      })
    } else {
      getClientDetailsOrders({
        page: currentPage,
        partnerDoc: customerDocument,
        status: statusSelected
      })
    }
  }, [currentPage, customer, type])

  const filterByName = (name) => {
    filter({
      partnerPhone: _.upperCase(name)
    })
  }

  return (
    <div>
      <div className={styles.header}>
        <h2>{isAsset ? "Números do cliente" : "Protocolos do cliente"}</h2>
      </div>
      <TableFixedVoice
        headers={headerSelected}
        records={records}
        actions={optionsSelected}
        type={type}
        page={currentPage}
        changePage={setCurrentPage}
        totalPages={totalPages}
        loading={loading}
        searchPlaceholder={"Pesquisar por telefone"}
        search={filterByName}
        registrationNotAllowed={isLimitAchieved}
        error={error}
      />
    </div>
  )
}

ClientNumbers.propTypes = {
  customer: PropTypes.object,
  numbers: PropTypes.object,
  loading: PropTypes.bool,
  isLimitAchieved: PropTypes.bool,
  error: PropTypes.string,
  type: PropTypes.string,
  status: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  filter: PropTypes.func,
  getClientDetailsAssets: PropTypes.func,
  getClientDetailsOrders: PropTypes.func
}

const mapStateToProps = ({ customersFixedVoice }) => ({
  numbers: customersFixedVoice.numbers,
  loading: customersFixedVoice.loadingNumbers,
  isLimitAchieved: customersFixedVoice.isLimitAchieved,
  error: customersFixedVoice.error
})

const mapActionsToProps = {
  getClientDetailsAssets,
  getClientDetailsOrders
}

export default connect(mapStateToProps, mapActionsToProps)(ClientNumbers)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/ClientDetails/ClientNumbers/index.js